import { baseApi } from "./apiConfig";

export const deleteSavedSearchPreference = async (data) => {
  try {
    const response = await baseApi.post(
      `/portal/drawer/deleteUserSavedSearch`,
      { emailId: data.emailId, searchId: data.searchId }
    );
    return response.data;
  } catch (error) {
    console.log("Error in Delete Search Preference API", error);
    throw error;
  }
};

export const getSavedProperties = async (emailId, pageNumber, pageSize) => {
  try {
    const payload = {
      emailId: emailId || "",
      pageNumber: pageNumber || 0,
      pageSize: pageSize || "3",
    };
    const response = await baseApi.post(
      "portal/drawer/getUserSavedProperties",
      payload
    );
    return response.data;
  } catch (error) {
    console.log("Error in get saved property api", error);
  }
};

export const getLatestLisiting = async({propertyId})=>{
  try {
    const response = await baseApi.get(`portal/buyerdashboard/getHighestOfferAmountForLatestListing/${propertyId}`);
    return response.data;
  } catch (error) {
    console.log(error,'in lastest lisiting');
    
  }
}